import UserAssignment_Collection from "../../model/collection";
import {USER_VIEW_TYPE} from "../../@type";
import ApiProject from "../../../../gd/api/project";
import ApiProjectUser from "../../../../gd/api/project-user";

export default class ModalProjectTeamActions {

    public params           : any
    public updateCallback   : callback
    public reassignCallback : {(view: USER_VIEW_TYPE, userAssignments: UserAssignment_Collection): void}
    public onReassignDone?  : callback
    public closeModal       : callback

    constructor(params: any, updateCallback: callback, reassignCallback: {(view: USER_VIEW_TYPE, userAssignments: UserAssignment_Collection): void}, closeModal: callback) {
        this.params             = params

        this.updateCallback     = updateCallback
        this.reassignCallback   = reassignCallback
        this.closeModal         = closeModal
    }

    onAccessSelect = async (value: any) => {

        try {
            const response = await ApiProjectUser.updateTeamAccess(this.params.projectUser.projectId, this.params.projectUser.teamId, value).promise()

            if (!!response.session) {
                this.params.projectUser.access = value

                this.updateCallback(()=>{
                    this.params.onChange?.(this.params.projectUser)
                })
            }

        } catch(e) {
            console.error(e)
        }
    }

    onDeleteConfirmed = async () => {
        try {
            const response = await ApiProject.deleteTeam(this.params.projectUser.projectId, this.params.projectUser.teamId, false).promise()

            const hasAssignments = !response.session

            const userAssignments: UserAssignment_Collection = UserAssignment_Collection.initFromJson(response, this.params.projectUser.team.userIds)

            const hasAssignmentsOnlyInOwner = userAssignments.hasAssignmentsOnlyInOwner(this.params.ownerUserId)

            if (hasAssignments && !hasAssignmentsOnlyInOwner) {
                this.reassignCallback(USER_VIEW_TYPE.REASSIGN_DELETE, userAssignments);
            } else {
                this.closeModal()
            }
        } catch (e) {
            console.error(e)
        }
    }

    reassignTeamItems = async (collection: UserAssignment_Collection) => {

        try {

            if (!collection.isEmpty) {
                await ApiProject.reassignItemsV2(this.params.projectUser.projectId, collection).promise();
            }

            await ApiProject.deleteTeam(this.params.projectUser.projectId, this.params.projectUser.teamId, false).promise()
            this.closeModal()
        } catch (e) {
            console.error(e)
        }
    }
}
